export default "__VITE_ASSET__0d24cafe__"